// GA4 event helper — safe no-op if gtag isn't loaded (e.g. dev / blocked).
// Send `generate_lead` (GA4 recommended event) for every lead-capture
// action and distinguish source with `method` ("form" | "whatsapp" | "phone").
export function trackEvent(name, params = {}) {
  if (typeof window === "undefined") return;
  if (typeof window.gtag !== "function") return;
  try {
    window.gtag("event", name, params);
  } catch (_) {
    // swallow — analytics must never break the UX
  }
}

export function trackLead({ method, location, country }) {
  trackEvent("generate_lead", {
    method,
    location: location || (typeof window !== "undefined" ? window.location.pathname : ""),
    ...(country ? { country } : {}),
    currency: "INR",
    value: 1,
  });
}
